import React from 'react';
import { FiCopy } from 'react-icons/fi';
import Text from 'core/components/Text';
import Button from 'core/components/Button';
import Tooltip from 'core/components/Tooltip';
import CopyToClipboardButton from 'app/components/CopyToClipboardButton';

interface IdTagProps {
  id?: string | number | null;
  small?: boolean;
  copyable?: boolean;
  intent?: string;
  isExport?: boolean;
}

const IdTag = ({
  id,
  small = false,
  copyable = true,
  intent = 'none',
  isExport = false
}: IdTagProps): React.ReactNode => {
  if (id == null || isExport) {
    return id ?? null;
  }

  const strId = String(id);
  const displayId = strId.length > 17 ? `${strId.slice(0, 4)}…${strId.slice(-12)}` : strId;
  const text = <Text monospace>{displayId}</Text>;

  if (!copyable) {
    return text;
  }

  const COPIED = 'Copied!';
  const pad = Math.max(0, displayId.length - COPIED.length);
  const copiedText = <Text monospace>{COPIED + '\u00A0'.repeat(pad)}</Text>; // Pad to reduce layout shift
  const stopPropagation = (e: React.SyntheticEvent) => e.stopPropagation();

  const button = (
    <div onClick={stopPropagation} onMouseDown={stopPropagation} onKeyDown={stopPropagation}>
      <CopyToClipboardButton text={strId} copyConfirmationText={copiedText} intent={intent}>
        <Button
          text={text}
          icon={FiCopy as unknown as React.ReactNode}
          iconSize={12}
          small={small}
          minimal
          py="3px"
          px="6px"
          ariaLabel="Copy ID"
          style={{ minHeight: 'unset' }}
        />
      </CopyToClipboardButton>
    </div>
  );

  return <Tooltip content="Copy to Clipboard">{button}</Tooltip>;
};

export default IdTag;
